import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isEmpty, isEqual } from "lodash";
/** Forms whose footer shows a summed total score. */
export var SCORED_FORMS = new Set(["nihss", "copd_cat_assessment_form"]);

/** Form whose footer shows a filled-field count. */
export var FIELD_COUNT_FORM = "lung_cancer";

/** Forms that display the eligibility disclaimer. */
export var DISCLAIMER_FORMS = new Set(["mt_sinai_eligibility", "mt_sinai_radiology_encounter"]);

/** Sums numeric response values for scored forms (NIHSS / COPD). */
export function computeScore(formName, response) {
  if (!SCORED_FORMS.has(formName)) return 0;
  var manual = response.manual_score;
  if (manual) return Number(manual);
  return Object.values(response).reduce(function (total, value) {
    return total + (_typeof(value) === "object" ? 0 : Number(value) || 0);
  }, 0);
}

/** Returns true when a required field has no usable value. */
export function hasEmptyRequiredFields(schema, response) {
  return schema.some(function (field) {
    if (!field.required) return false;
    var value = response[field.id];
    if (typeof value === "number") return false;
    if (value instanceof Date) return Number.isNaN(value.getTime());
    if (typeof value === "string") return isEmpty(value.trim());
    return isEmpty(value);
  });
}

/** Returns true when the form has at least one value and no missing required field. */
export function isFormSubmittable(schema, response, initialResponse) {
  var hasValue = Object.values(response).some(function (value) {
    return value === true || (value instanceof Date ? !Number.isNaN(value.getTime()) : !isEmpty(value));
  });
  if (!hasValue) return false;
  if (hasEmptyRequiredFields(schema, response)) return false;
  return !isEqual(response, initialResponse);
}

/**
 * Splits the response into a create payload (media stripped, dates stringified)
 * and the list of media files to attach after creation.
 */
export function buildSubmitPayload(schema, response, formName, displayName) {
  var cleaned = _objectSpread({}, response);
  var mediaFiles = [];
  schema.forEach(function (field) {
    var value = cleaned[field.id];
    if (field.response_type === "upload" && value instanceof File) {
      mediaFiles.push({
        fieldId: field.id,
        file: value
      });
      delete cleaned[field.id];
    }
    if (field.response_type === "date" && typeof value === "string" && value) {
      cleaned[field.id] = new Date(value).toDateString();
    }
    if (field.response_type === "datetime" && typeof value === "string" && value) {
      cleaned[field.id] = new Date(value).toISOString();
    }
  });
  return {
    payload: {
      form_name: formName,
      form_display_name: displayName,
      response: cleaned
    },
    mediaFiles: mediaFiles
  };
}